<template>
	<az-container class="listagem">
		<v-card tile elevation="0">
			<v-row no-gutters>
				<v-col cols="4">
					<v-card-text class="ma-0 pl-2 pt-5">
						<v-form v-model="isFormValid" ref="frmGerarRelatorioAdesao" lazy-validation>
							<v-row>
								<v-col cols="12" sm="12">
									<label-personalizado
										nome-campo="Nº Ata"
										obrigatorio-por-padrao
										class="label-campos"
									></label-personalizado>
									<v-autocomplete
										v-model="idAta"
										:items="ataDataSource"
										placeholder="Busque pelo número da ata"
										class="ma-0 py-2"
										name="NumeroAta"
										clearable
										item-text="numeroAta"
										item-value="idAta"
										:rules="numeroAtaRules"
										:search-input.sync="campoNumeroAta"
										@update:search-input.capture="buscarAtas()"
										@keydown.enter.native.prevent
									></v-autocomplete>
								</v-col>
							</v-row>
						</v-form>
					</v-card-text>
				</v-col>
				<v-col cols="auto" class="d-flex align-center">
					<v-card-actions>
						<botao-primario
							nome-botao="Gerar"
							@click="gerarRelatorioAdesoes"
							v-az-auth="permissoes.relatorioControleAdesoes"
							:disabled="!isFormValid"
						></botao-primario>
					</v-card-actions>
				</v-col>
			</v-row>
		</v-card>
		<modal-confirmacao
			titulo-modal="Tudo certo, relatório em processamento"
			mensagem="Relatório adicionado na fila para processamento e será encaminhado por e-mail assim que for concluído."
			:exibir="exibirModalInformativo"
			@cancelar="exibirModalInformativo = false"
			icone-modal="task_alt"
			cor-icone="#A5DC86"
		>
			<template #acoes>
				<botao-primario nomeBotao="Voltar" @click="exibirModalInformativo = false"></botao-primario>
			</template>
		</modal-confirmacao>
	</az-container>
</template>

<script>
import BotaoPrimario from '@/views/components/BotaoPrimario'
import LabelPersonalizado from '@/views/components/LabelPersonalizado'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import { actionTypes } from '@/core/constants'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	name: 'controle-adesoes',
	components: { LabelPersonalizado, BotaoPrimario },
	mixins: [validacaoFormulario],
	data() {
		return {
			isFormValid: true,
			numeroAtaRules: [(v) => this.regraObrigatoriedade(v, 'Número ata é obrigatório.')],
			ataDataSource: [],
			idAta: null,
			campoNumeroAta: null,
			paginacaoCampoAta: paginacaoListagem('', 100),
			exibirModalInformativo: false,
		}
	},
	async mounted() {
		await this.buscarAtas()
	},
	methods: {
		async buscarAtas() {
			const { itens } = await this.$store.dispatch(actionTypes.RELATORIOS.CONTROLE_ADESOES.BUSCAR_ATAS, {
				paginacao: this.paginacaoCampoAta,
				numeroAta: this.campoNumeroAta ? this.campoNumeroAta.trim() : null,
			})

			this.ataDataSource = itens
		},
		async gerarRelatorioAdesoes() {
			if (this.$refs.frmGerarRelatorioAdesao.validate()) {
				await this.$store
					.dispatch(actionTypes.RELATORIOS.CONTROLE_ADESOES.GERAR_RELATORIO, this.idAta)
					.then((resp) => {
						if (resp === 0) this.exibirModalInformativo = true
					})
			}
		},
	},
}
</script>
<style scoped lang="stylus">
.label-campos
	color rgba(0, 0, 0, 0.54) !important
</style>
